<template>
  <div class="sect-section">
    <div class="container">
      <div class="row mb-5">
        <div class="col-12 text-center">
          <h1 class="sect-title">Loja do Elysium</h1>
          <p class="lead text-muted" style="color: #e9ecef !important;">
            Vitrine de artefatos para crônicas da Jyhad com itens selecionados!
          </p>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-md-6 col-xl-4" v-for="item in items" :key="item.id">
          <article class="card store-card h-100">
            <div class="store-card-image" :style="{ backgroundImage: `url(${item.image})` }" role="img"
              :aria-label="`Imagem do produto ${item.name}`"></div>
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="badge bg-dark text-warning text-uppercase">{{ item.category }}</span>
                <small class="text-muted">{{ item.theme }}</small>
              </div>
              <h5 class="card-title">{{ item.name }}</h5>
              <p class="card-text text-muted flex-grow-1">{{ item.tagline }}</p>
              <div class="mt-3 d-flex flex-wrap gap-2">
                <span v-for="tag in item.tags" :key="tag" class="badge rounded-pill bg-secondary-subtle text-dark">
                  <i class="bi bi-hash me-1"></i>{{ tag }}
                </span>
              </div>
              <button class="btn btn-vampire mt-4" type="button" @click="openItem(item)">
                <i class="bi bi-eye me-2"></i>
                Ver detalhes
              </button>
            </div>
          </article>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 text-center">
          <button class="btn btn-outline-light" @click="$emit('go-back')">
            <i class="bi bi-arrow-left me-2"></i>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>

    <transition name="modal-fade-zoom">
      <div v-if="selectedItem" class="store-modal-overlay" @click.self="closeModal">
        <div class="store-modal-dialog" role="dialog" aria-modal="true">
          <div class="store-modal-content">
            <header class="store-modal-header">
              <div>
                <h4 class="store-modal-title">{{ selectedItem.name }}</h4>
                <p class="store-modal-subtitle mb-0">{{ selectedItem.tagline }}</p>
              </div>
              <button class="btn-close btn-close-white" type="button" @click="closeModal"></button>
            </header>

            <section v-if="selectedItem.gallery?.length" class="store-modal-gallery">
              <div class="store-modal-gallery-main" :style="{ backgroundImage: `url(${activeImage})` }"></div>
              <div class="store-modal-gallery-thumbs">
                <button v-for="image in selectedItem.gallery" :key="image" type="button" class="store-modal-thumb"
                  :class="{ active: image === activeImage }" @click="activeImage = image"
                  :style="{ backgroundImage: `url(${image})` }">
                  <span class="visually-hidden">Imagem do produto</span>
                </button>
              </div>
            </section>

            <section class="store-modal-body">
              <p class="text-muted mb-3">{{ selectedItem.description }}</p>
              <ul class="list-unstyled mb-4">
                <li v-for="feature in selectedItem.features" :key="feature" class="mb-2">
                  <i class="bi bi-droplet-half me-2 text-danger"></i>{{ feature }}
                </li>
              </ul>

              <div class="store-modal-footer d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
                <div>
                  <span class="badge bg-danger text-uppercase me-2">{{ selectedItem.category }}</span>
                  <span class="text-warning fw-semibold">{{ selectedItem.priceRange }}</span>
                </div>
                <a class="btn btn-vampire" :href="selectedItem.affiliateLink" target="_blank" rel="noopener">
                  <i class="bi bi-box-arrow-up-right me-2"></i>
                  Comprar agora
                </a>
              </div>
            </section>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import vMRenegadeDiceSet01 from '../assets/storeImages/renegade_dice_set_01.jpg'
import vMRenegadeDiceSet02 from '../assets/storeImages/renegade_dice_set_02.jpg'
import vMRenegadeDiceSet03 from '../assets/storeImages/renegade_dice_set_03.jpg'
import vMMasterShield01 from '../assets/storeImages/galapagos_vm_master_shield_01.jpg'
import vMMasterShield02 from '../assets/storeImages/galapagos_vm_master_shield_02.jpg'
import vMMasterShield03 from '../assets/storeImages/galapagos_vm_master_shield_03.jpg'
import vMRuleBookV501 from '../assets/storeImages/vm_rule_book_v5.jpg'
import vMRuleBookV502 from '../assets/storeImages/vm_rule_book_v5_02.jpg'
import vMRuleBookV503 from '../assets/storeImages/vm_rule_book_v5_03.jpg'



export default {
  name: 'StoreView',
  data() {
    return {
      items: [
        {
          id: 'vampiro-rule-book',
          name: 'Vampiro: A Máscara 5ª Edição',
          category: 'Livro',
          theme: 'Vampiro • Crônica Moderna',
          tagline: 'O tomo essencial para narradores e coteries que mergulham na Noite Moderna.',
          description:
            'Edição completa do Livro de Regras 5ª Edição, trazendo o sistema de Fome, Ambições e toda a política da Jyhad para sua mesa com luxo e acabamento premium.',
          priceRange: 'Faixa de preço: R$ 220 - R$ 300 (Amazon Brasil)',
          image: vMRuleBookV501,
          gallery: [
            vMRuleBookV501,
            vMRuleBookV502,
            vMRuleBookV503
          ],
          features: [
            'Sistema oficial com cronologia atualizada pós-Gehenna.',
            'Perfis completos dos clãs, disciplinas e antagonistas.',
            'Ferramentas para montar coteries temáticas e missões políticas.'
          ],
          tags: ['Regras Oficiais', 'Narrador', 'Coteries'],
          affiliateLink: 'https://www.amazon.com.br/Gal%C3%A1pagos-Jogos-WOD001-Vampiro-M%C3%A1scara/dp/6586644267/ref=sr_1_3?crid=SVRKIFEUGNWN&dib=eyJ2IjoiMSJ9.eO8GJmjuOIXXsOcdSMIiyszFIvFmHX5ZeIpjCUNtBrvaQYflpjmWiPO9LkD_hQOpp_E2c6PRSGTldyo6peL3EpmO3tZEDFnc8Ik3tNyM3SmlxLXs1s8boq1OWiMv2TaGbXd24PliMtEky2Q9UoQrlQSQe0F3xbsCJf0k-jFVr-MciB3N6RlJiDv-QDfHuNob4FvlSBLtBXoZVwH-2-cIrLOpE2PHsXOic7kGmXkfSNi8ngoijeKK6KxwOpo9evj7MZTpcJvgOjNHGdPH1oEYX0skpPKdQw5uqZ4XDVW4EX4.hEgcu3kc1UZtqqRAufNjeDoOXJyZB_E2bTfCt-pTuhc&dib_tag=se&keywords=vampiro+a+mascara+5+edi%C3%A7%C3%A3o&qid=1764622126&sprefix=vampiro+a+mascara+%2Caps%2C208&sr=8-3'
        },
        {
          id: 'master-shield-vm',
          name: 'Galápagos, Vampiro: A Máscara - Escudo do Narrador, Acessório de RPG',
          category: 'Jogo de rpg',
          theme: 'acessório para mestres',
          tagline: 'acessório para mestres',
          description:
            'Complemente sua coleção de Vampiro: A Máscara com o Escudo do Narrador. Este escudo é essencial para manter anotações e jogadas de dados fora do campo de visão dos outros participantes, garantindo privacidade e imersão total na narrativa. A arte e a qualidade excepcionais do escudo proporcionam uma experiência de jogo fantástica, ideal para narradores que buscam um recurso valioso para suas sessões.',
          priceRange: 'Faixa de preço: R$ 49,90 - R$ 99,90 (Amazon Brasil)',
          image: vMMasterShield01,
          gallery: [
            vMMasterShield01,
            vMMasterShield02,
            vMMasterShield03
          ],
          features: [
            'Modo competitivo para 2 ou mais jogadores com múltiplos objetivos de vitória.'
          ],
          tags: ['acessório', 'rpg', 'mestre'],
          affiliateLink: 'https://www.amazon.com.br/Vampiro-M%C3%A1scara-Narrador-Gal%C3%A1pagos-Multicolor/dp/658664433X/ref=sr_1_1?__mk_pt_BR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=2D36VR3AYFI3Y&dib=eyJ2IjoiMSJ9.IQob6sHqndNaYzwGVuMK9DoujZYUj-NVxzIyq2xRTGX7Ff7dCm_Eg7q0-6IFxX3JldzSoxF34iKB2k_zi2bpGg.uYt-quQsJAsftgHZ5QmxHtKCBLALvvCs59mn454nc_Q&dib_tag=se&keywords=vampiro+a+mascara+mestre&qid=1764620946&sprefix=vampiro+a+mascara+mestr%2Caps%2C271&sr=8-1'
        },
        {
          id: 'dice-set-renegade',
          name: 'Renegade Games Studios Vampire: The Masquerade - Dice Set (Preto & Vermelho)',
          category: 'Acessório',
          theme: 'Crônicas Intensivas',
          tagline: 'Dados temáticos para intensificar os testes das jogadas.',
          description:
            'Conjunto oficial com dados vermelhos e pretos, símbolos de Ankh e sucesso crítico, pronto para compor o altar da sua mesa de jogo.',
          priceRange: 'Faixa de preço: R$ 150 - R$ 220 (Amazon Brasil)',
          image: vMRenegadeDiceSet01,
          gallery: [
            vMRenegadeDiceSet01,
            vMRenegadeDiceSet02,
            vMRenegadeDiceSet03
          ],
          features: [
            'Inclui 18 dados personalizados com ícones icônicos.',
            'Compatível com todas as edições modernas do sistema Storyteller.',
            'Ideal para kits de apresentação de narradores e eventos de loja.'
          ],
          tags: ['Acessórios', 'Dados', 'teste de rolagem'],
          affiliateLink: 'https://www.amazon.com.br/Vampiro-Renegade-Games-Conjunto-Masquerade/dp/B09FFZ7SMV/ref=sr_1_1?__mk_pt_BR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=HN97YYULJVTT&dib=eyJ2IjoiMSJ9.9yNTmEWfiqSYVRlcOkw-KBAIxwf4RZovtqduGNaE1andn0ZHDH1nj23uTiiow6Lo3ffAHto2ATgZnYJj2d4g-3fKBWAn-67WsjjXTHDL6XWmxw5L4pVw7p0H5Dp2HRGLUzWfVj-BaIH3IxtZYEGQhuYqxOUUMHqokCgYaLrxrTweTZ1rR8WM4upeZdouG0qD9DDCpcZLDWZ2CtH2y_Rldbhm76Sl0G2qP-GCIMaY0qPSsVLoRtRFQaKoHoPEOzPhqTgv2fM8AgzNqsOvY-NEswDBDxPAD_1s6H47cOtmWJU.gBoufBogUtEtSwbMr8P8S0PYZRf-zgmaKyeezGHdzFE&dib_tag=se&keywords=Vampire%3A%2BThe%2BMasquerade%2B-%2BDice%2BSet&qid=1764618885&sprefix=vampire%2Bthe%2Bmasquerade%2B-%2Bdice%2Bset%2Caps%2C376&sr=8-1&ufe=app_do%3Aamzn1.fos.db68964d-7c0e-4bb2-a95c-e5cb9e32eb12&th=1'
        }
      ],
      selectedItem: null,
      activeImage: ''
    }
  },
  methods: {
    openItem(item) {
      this.selectedItem = item
      this.activeImage = item.gallery?.[0] || item.image
    },
    closeModal() {
      this.selectedItem = null
      this.activeImage = ''
    }
  }
}
</script>

<style scoped>
.store-card {
  background: rgba(17, 17, 17, 0.92);
  border: 1px solid rgba(218, 165, 32, 0.25);
  color: #f8f9fa;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.store-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 32px rgba(0, 0, 0, 0.45);
}

.store-card-image {
  width: 100%;
  height: 260px;
  max-height: 300px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #111;
}

.store-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1080;
  padding: 2rem;
}

.store-modal-dialog {
  width: 100%;
  max-width: 960px;
  max-height: 92vh;
}

.store-modal-content {
  background: rgba(18, 18, 18, 0.96);
  border: 1px solid rgba(218, 165, 32, 0.35);
  border-radius: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 92vh;
}

.store-modal-header {
  padding: 1.5rem 1.75rem;
  border-bottom: 1px solid rgba(218, 165, 32, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}

.store-modal-title {
  margin: 0;
  color: var(--vampire-gold);
  font-size: 1.4rem;
}

.store-modal-subtitle {
  color: rgba(233, 236, 239, 0.75);
}

.store-modal-gallery {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1.75rem 0;
}

.store-modal-gallery-main {
  width: 100%;
  height: 360px;
  border-radius: 0.75rem;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #111;
  border: 1px solid rgba(218, 165, 32, 0.25);
}

.store-modal-gallery-thumbs {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.store-modal-thumb {
  width: 80px;
  height: 80px;
  border-radius: 0.5rem;
  border: 2px solid transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: 0.25s ease;
  opacity: 0.7;
}

.store-modal-thumb:hover,
.store-modal-thumb.active {
  opacity: 1;
  border-color: rgba(218, 165, 32, 0.45);
  transform: translateY(-2px);
}

.store-modal-body {
  padding: 1.75rem;
  overflow-y: auto;
}

.store-modal-body::-webkit-scrollbar {
  width: 8px;
}

.store-modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(218, 165, 32, 0.4);
  border-radius: 999px;
}

.store-modal-footer {
  padding-top: 1rem;
  border-top: 1px solid rgba(218, 165, 32, 0.2);
}

@media (max-width: 768px) {
  .store-modal-dialog {
    padding: 0;
  }

  .store-modal-gallery-main {
    height: 220px;
  }
}
</style>
